export default __webpack_public_path__ + "static/media/chevron-white.2bfab632.svg";